module.exports = __webpack_public_path__ + "static/media/3-master-klassy.880a62c8.jpg";